import type { StyleLibrary } from "schemas/generated/project";

import { useCallback } from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpcClient } from "@editor/utils/trpc";

import { useWebContainer } from "@/features/web-container/context";

/**
 * Hook to fetch and update globals.css in the web container with the latest
 * style library changes. This is used across design library components to
 * provide fast, targeted updates instead of refreshing the entire file tree.
 */
export const useFetchGlobalsCssForWebContainer = () => {
  const projectId = useCurrentProjectId();
  const { mountAdditionalFiles } = useWebContainer();

  const updateGlobalsCss = useCallback(
    async (styleLibrary?: StyleLibrary) => {
      if (!projectId) {
        return;
      }

      const fileTree =
        await trpcClient.webContainer.getGlobalsCssFileTree.query({
          projectId,
          styleLibrary,
        });
      await mountAdditionalFiles?.(fileTree);
    },
    [projectId, mountAdditionalFiles],
  );

  return updateGlobalsCss;
};
